import Authenticated from "@/components/auth/Authenticated";
import { SCLink } from "@/components/common/SCLink";
import { ScrollToTop } from "@/components/common/ScrollToTop";
import { GeneralError } from "@/components/sleep_checkup_v1/GeneralError";
import constants from "@/utils/constants";
import { Button, LinearProgress, Stack, Typography } from "@mui/material";
import { Link, LinkProps, useParams } from "react-router-dom";

export function RingIdScanIntroduction() {
  const params = useParams();

  if (params.sleepCheckupUuid == null) {
    return (
      <GeneralError
        to="/examinee/signup"
        buttonText="アカウント登録をやり直す"
      />
    );
  }

  const state = { sleepCheckupUuid: params.sleepCheckupUuid };

  return (
    <Authenticated redirectTo={constants.SIGNIN_URL_EXAMINEE}>
      <ScrollToTop />
      <LinearProgress
        variant="determinate"
        value={(5 / 6) * 100}
        sx={{
          borderRadius: 1,
          mx: 4,
          my: 6,
          height: "6px",
        }}
      />
      <Stack sx={{ mb: 16 }}>
        <Stack sx={{ py: 6, mx: 4 }}>
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontFamily: "Noto Sans JP",
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: "170%",
              letterSpacing: "0.15px",
            }}
          >
            デバイスIDの登録
          </Typography>
          <Typography
            variant="subtitle2"
            align="center"
            sx={{
              fontFamily: "Noto Sans JP",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "190%",
              letterSpacing: "0.1px",
              color: "text.secondary",
            }}
          >
            （リング型デバイス）
          </Typography>
        </Stack>
        <Stack sx={{ gap: 4, pb: 6, mx: 4 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Noto Sans JP",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "190%",
              letterSpacing: "0.1px",
              textAlign: "justify",
              color: "text.secondary",
            }}
          >
            続いて「リング型デバイス」の登録を行います。本ページ下部の[QRコードを読み取る]ボタンを押して、お使いのスマートフォンで収納ケースの外装に表示されているQRコードを読み取ってください。
          </Typography>
          <DeviceIntroductionImage src="/img/image_ring_id_scan_introduction.png" />
        </Stack>
        <Stack spacing={4} sx={{ py: 6, mx: 4 }}>
          <QRCodeScanButton
            title="QRコードを読み取る"
            subTitle="※カメラが起動します"
            to="/examinee/ring_id_scan"
            state={state}
          />
          <SCLink
            variant="body2"
            to="/examinee/ring_id_input"
            state={state}
            sx={{ color: "text.secondary" }}
          >
            うまく読み取れない場合
          </SCLink>
        </Stack>
      </Stack>
    </Authenticated>
  );
}

type DeviceIntroductionImageProps = {
  src: string;
};
function DeviceIntroductionImage({ src }: DeviceIntroductionImageProps) {
  return (
    <img
      src={src}
      alt="デバイスIDの登録"
      loading="lazy"
      style={{ width: "100%", height: "auto" }}
    />
  );
}

type QRCodeScanButtonProps = {
  title: string;
  subTitle: string;
  to: LinkProps["to"];
  state: LinkProps["state"];
};
function QRCodeScanButton({
  title,
  subTitle,
  to,
  state,
}: QRCodeScanButtonProps) {
  return (
    <Button
      component={Link}
      to={to}
      state={state}
      variant="contained"
      size="large"
    >
      <Stack alignItems="center">
        <Typography variant="button" color="white" fontSize="15px">
          {title}
        </Typography>
        <Typography variant="caption" color="white">
          {subTitle}
        </Typography>
      </Stack>
    </Button>
  );
}
